import React, { useState, useEffect } from 'react';
import { fetchUserPermissions, upsertUserPermission } from '../../services/Administracion/userPermissionService';
import { fetchUsers } from '../../services/Administracion/usersService';
import { fetchPermissions } from '../../services/Administracion/permissionService';
import { User } from '../../types/users';
import { Permission } from '../../types/permission';
import { useAuth } from '../../context/AuthContext';
import { UserPermission } from '../../types/userPermission';
import UserPermissionModal from '../Administracion/UserPermissionModal';

const UserPermissionList: React.FC = () => {
    const { user } = useAuth();
    const [users, setUsers] = useState<User[]>([]);
    const [permissions, setPermissions] = useState<Permission[]>([]);
    const [userPermissions, setUserPermissions] = useState<UserPermission[]>([]);
    const [selectedUserPermission, setSelectedUserPermission] = useState<UserPermission | null>(null);
    const [showModal, setShowModal] = useState<boolean>(false);
    const [loading, setLoading] = useState<boolean>(false);
    const [error, setError] = useState<string | null>(null);

    const loadData = async () => {
        setLoading(true);
        setError(null);
        try {
            const [userPermissionData, usersData, permissionsData] = await Promise.all([
                fetchUserPermissions(),
                fetchUsers(),
                fetchPermissions()
            ]);
            setUsers(usersData);
            setPermissions(permissionsData);
            setUserPermissions(userPermissionData);
        } catch (error: any) {
            setError(error.message || 'Error al cargar datos');
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        loadData();
    }, []);

    const handleOpenModal = (userPermission?: UserPermission) => {
        setSelectedUserPermission(userPermission || null);
        setShowModal(true);
    };

    const handleSaveUserPermission = async (userPermission: UserPermission) => {
        try {
            userPermission.created_by = user?.User.email;
            userPermission.updated_by = user?.User.email;

            await upsertUserPermission(userPermission);
            loadData();
        } catch (error: any) {
            setError(error.message || 'Error al guardar el permiso del usuario');
        } finally {
            setShowModal(false);
        }
    }
    if (loading) return <div>Cargando...</div>;
    if (error) return <div>Error: {error}</div>;
    
    return (
        <div className="container mt-4">
            <h4>Asignar Permisos Directos a Usuarios</h4>
            <div className="mb-3 text-end">
                <button
                    className="btn btn-primary"
                    onClick={() => handleOpenModal()}
                >
                    Agregar Permiso a usuario
                </button>
            </div>
            <table className="table table-stripped">
                <thead>
                    <tr>
                        <th>Usuario</th>
                        <th>Permiso</th>
                        <th>Activo</th>
                        <th>Acciones</th>
                    </tr>
                </thead>
                <tbody>
                    {userPermissions.map((up, index) => {
                        const user = users.find(u => u.user_id === up.user_id);
                        const permission = permissions.find(p => p.permission_id === up.permission_id);
                        return (
                            <tr key={index}>
                                <td>{user?.ad_username}</td>
                                <td>{permission?.permission_name}</td>
                                <td>{up.is_active ? 'Sí' : 'No'}</td>
                                <td>
                                    <button
                                        className="btn btn-secondary btn-sm"
                                        onClick={() => handleOpenModal(up)}
                                    >
                                        Editar
                                    </button>
                                </td>
                            </tr>
                        )
                    })}
                </tbody>
            </table>
            {showModal && (
                <UserPermissionModal
                    userPermission={selectedUserPermission}
                    userPermissions={userPermissions}
                    users={users}
                    permissions={permissions}
                    onSave={handleSaveUserPermission}
                    onClose={() => setShowModal(false)}
                />
            )}
        </div>
    )
};

export default UserPermissionList;